



























import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop, VModel, Watch } from "vue-property-decorator";
import { Paginacao } from "../../interface";
import { PageOptions } from "../../utils/datatable";

export interface AutoCompletePageOptions extends PageOptions {
  search?: string;
}

@Component
export default class AutoComplete<T> extends Vue {
  @Prop({ required: true }) readonly label!: string;
  @Prop({ required: false, type: Boolean, default: false })
  readonly rounded!: boolean;
  @Prop() readonly itemValue!: string;
  @Prop() readonly itemText!: string;
  @VModel() val!: any;
  @Prop() items!: T[] | Promise<T[] | Paginacao<T>>;
  @Prop({ required: false, default: () => [] }) readonly rules!: Array<
    (value: any) => string | null | undefined
  >;
  @Prop({ required: false }) readonly placeholder!: string;
  @Prop({ required: false, default: "mdi-menu-down" })
  readonly appendIcon!: string;
  @Prop({ required: false, type: Function })
  readonly filter!: (item: T, queryText: string, itemText: string) => boolean;

  itemsValue: T[] | null = null;
  search: string | null = null;

  options: PageOptions = {};
  server = false;

  loading = false;
  totalRegistros = 0;

  get canLoadMore(): boolean {
    return this.server && (this.itemsValue?.length || 0) < this.totalRegistros;
  }

  @Emit("onOptionsChange")
  onOptionsChange(options: AutoCompletePageOptions) {
    return options;
  }

  timeout: number | null = null;
  @Watch("search")
  onSearchChange(search: string) {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.options.page = 1;
      this.onOptionsChange(Object.assign({ search }, this.options));
    }, 600);
  }

  @Watch("items", { immediate: true })
  async fetchItems() {
    if (this.items && !Array.isArray(this.items)) {
      this.loading = true;
      this.items
        .then((items) => {
          if (Array.isArray(items)) {
            this.itemsValue = items;
          } else {
            this.server = true;
            this.options.itemsPerPage = items.tamanhoPagina;

            if (items.paginaAtual == 1) {
              this.itemsValue = items.lista;
            } else {
              this.itemsValue = [...(this.itemsValue || []), ...items.lista];
            }

            this.totalRegistros = items.totalRegistros;
            this.options.page = items.paginaAtual;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.itemsValue = this.items;
    }
  }

  carregarMais() {
    this.options.page = (this.options.page || 1) + 1;
    this.onOptionsChange(
      Object.assign({ search: this.search || "" }, this.options)
    );
  }
}
